<template>
    <el-dialog
        title="鸿合回单"
        class="hongHeDialog"
        :closeOnClickModal='false'
        :visible.sync="hongHeDialogVisible"
        width="700px"
        :before-close="handleClose">
        <div class="title">
            <span class="title-text">客户订单号： {{rowData.customerOrderNo}}</span>
            <span class="title-text">运输单号： {{rowData.taskNo}}</span>
            <span>备注： {{rowData.remark}}</span>
        </div>
            <el-table
                :data="tableData"
                height="220"
                v-loading = loading
                style="width: 100%">
                <el-table-column
                  label="序号"
                  type="index"
                  align="center"
                  width="50">
                </el-table-column>
                <el-table-column
                  prop="imageType"
                  label="图片类型"
                  align="center"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="uploadName"
                  label="操作人"
                  align="center"
                  width="110">
                </el-table-column>
                <el-table-column
                  prop="uploadTime"
                  label="上传时间"
                  align="center"
                  width="160">
                </el-table-column>
                <el-table-column
                  prop="downUrl"
                  label="图片预览"
                  align="center"
                  width="80">
                <template slot-scope="scope">
                    <div v-if='scope.row.downUrl' style="line-height: 0px;">
                        <img src="@/assets/photos.png" @click.stop='photosBtn(scope.row)' @dblclick.stop="" style="width: 20px; cursor: pointer;">
                    </div>
                 </template>
                </el-table-column>
                <el-table-column
                  label="操作栏"
                  align="center"
                  width="145">
                  <template slot-scope="scope">
                    <el-button class="btnClass" title="上传" v-if="!scope.row.downUrl"  @click="uploadBtn(scope.row)" type="text"  icon="el-icon-plus"></el-button>
                    <el-button class="btnClass" title="删除" v-if="scope.row.downUrl && +rowData.hongheFlag !== 2"  @click="deleteClick(scope.row)" type="text"  icon="el-icon-delete"></el-button>
                    <el-button class="btnClass" title="下载" v-if="scope.row.downUrl"  @click="downloadClick(scope.row)" type="text"  icon="el-icon-download"></el-button>
                  </template>
                </el-table-column>
            </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button v-if="+rowData.hongheFlag !== 2" type="primary" @click="uploadReport">报告上传</el-button>
        </span>
         <!-- 上传按钮使用的组件 -->
        <upload class="avatar-uploader" @callback='uploadResponse' :loading.sync='loading'>
            <i ref='upload'></i>
        </upload>
        <!-- 图片预览 -->
        <attachment-dialog v-if='attachmentShow' :attachmentShow.sync='attachmentShow' :rowData='rows'>
        </attachment-dialog>
</el-dialog>
</template>
<script>
import attachmentDialog from './attachmentDialog';
import upload from './upload.vue';
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import { queryReceiptFileByHonghe, insertReceiptFileByHonghe } from '../../../../api/receiptSign';
export default {
    components: { attachmentDialog, upload },
    props: {
        hongHeDialogVisible: {
            type: Boolean,
            default: false
        },
        rowData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            attachmentShow: false,
            loading: false,
            rows: {},
            key: '',
            tableData: [{
                uploadTime: '',
                uploadName: '',
                imageType: '签收单',
                downUrl: '',
                key: 0
            }, {
                uploadTime: '',
                uploadName: '',
                imageType: '安装单',
                downUrl: '',
                key: 1
            }, {
                uploadTime: '',
                uploadName: '',
                imageType: '开机画面',
                downUrl: '',
                key: 2
            }, {
                uploadTime: '',
                uploadName: '',
                imageType: '旧机打包',
                downUrl: '',
                key: 3
            }, {
                uploadTime: '',
                uploadName: '',
                imageType: 'OPS安装',
                downUrl: '',
                key: 4
            }]
        };
    },
    methods: {
        async  getData() {
            const params = {
                customerOrderNo: this.rowData.customerOrderNo
            };
            this.loading = true;
            await queryReceiptFileByHonghe(params).then(res => {
                if (res && +res.code === 0 && res.data.length) {
                    res.data.sort(this.compare('key', true));
                    this.tableData = res.data;
                }
            });
            this.loading = false;
        },
        compare(property, desc) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                if (desc === true) {
                    // 升序排列
                    return value1 - value2;
                } else {
                    // 降序排列
                    return value2 - value1;
                }
            };
        },
        handleClose() {
            this.$emit('update:hongHeDialogVisible', false);
        },
        uploadBtn(data) {
            this.key = data.key;
            this.$refs.upload.click();
        },
        uploadResponse(response) {
            const nowDate = new Date();
            const nowTime = dayjs(nowDate).format('YYYY-MM-DD HH:mm:ss');
            this.tableData[this.key].downUrl = response[0].data.downUrl;
            this.tableData[this.key].uploadName = this.user.userName;
            this.tableData[this.key].uploadTime = nowTime;
            this.loading = false;
        },
        photosBtn(data) {
            this.rows = data;
            this.attachmentShow = true;
        },
        deleteClick(data) {
            this.tableData[data.key].uploadTime = '';
            this.tableData[data.key].uploadName = '';
            this.tableData[data.key].downUrl = '';
        },
        downloadClick(data) {
            window.location = data.downUrl;
        },
        async uploadReport() {
            let allUpload = false;
            allUpload = this.tableData.every(item => {
                return item.downUrl;
            });
            if (!allUpload) {
                return this.$message.warning('必须上传所有图片类型才能进行报告上传！');
            }
            this.tableData.map(item => {
                if (item.id) {
                    delete item.id;
                }
                return item;
            });
            const params = {
                customerOrderNo: this.rowData.customerOrderNo,
                taskNo: this.rowData.taskNo,
                tableData: this.tableData
            };
            await insertReceiptFileByHonghe(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('报告上传成功');
                }
            });
            this.$emit('hongHeDialogClose');
        }
    },
    mounted() {
        this.getData();
    },
    computed: {
        ...mapState({
            user: state => state.user
        })
    }
};
</script>
<style lang="less">
.hongHeDialog{
    .btnClass{
        font-size: 16px;
    }
    .title{
        font-size: 14px;
        margin-bottom: 10px;
        margin-left: 10px;
        .title-text{
            margin-right: 20px;
        }
    }
}
</style>
